export const FIRMSTYPESLIST_GET_FIRMSTYPESLIST = "firms/get-firms-types-list";
